import { Component, HostListener, Input, LOCALE_ID, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from '../header.component';
import { CommonModule } from '@angular/common';
import { Customer } from '@shared/models/customer/customer.model';
import { User } from '@shared/models/user/user.model';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { UserStore } from '@shared/stores/user/user.store';
import { buildUrl } from '@shared/utilities/common.utils';
import { CustomerStore } from '@shared/stores/customer/customer.store';

@Component({
    selector: 'avenir-top-header',
    imports: [
        CommonModule
    ],
    templateUrl: './top-header.component.html',
    styleUrl: './top-header.component.scss'
})
export class TopHeaderComponent {
  @Input() phoneNumber: string = '1-800-555-1212';
  @Input() rightMenuItems!: MenuItem[];
  @Input() currentCustomerId: string = '';

  //follow breakpoints.scss
  $l: number = 992;

  hideAt$l: boolean = false;

  user!: User;
  userAcronym: string = '';
  name: string = '';
  displayMenu: boolean = false;
  profileUrl: string = '';
  accountId: string = '';
  accountName: string = '';
  customers: Customer[] = [];

  constructor(
    private router: Router,
    private userStore: UserStore,
    protected customerStore: CustomerStore,
    @Inject(LOCALE_ID) public activeLocale: string
  ){}

  ngOnInit(){
    this.checkWidth(Math.min(window.outerWidth, window.innerWidth));
    this.userStore.user$.subscribe(user => {
      this.user = this.userStore.getUser();
      this.extractUserAcronymAndOtherDetails();
      if (this.currentCustomerId) {
        this.profileUrl = buildUrl(SITE_LINKS.PROFILE.BASE, this.currentCustomerId, this.user.userId);  
      }
    })
  }
  

  extractUserAcronymAndOtherDetails(): void {
    if (this.user && this.user.firstname && this.user.lastname) {
      this.userAcronym = `${this.user.firstname.charAt(0)}${this.user.lastname.charAt(0)}`;
      this.accountId = this.user.customers[0].legacyId ? this.user.customers[0].legacyId?.trim() : '';
      this.accountName = this.user.customers[0].name ? this.user.customers[0].name?.trim() : '';


      this.customers = this.user.customers;

    } else {
      this.userAcronym = '';
    }
  }

  goToPage(url: string, event: Event, redirect: boolean = true){
    if(!redirect){
      event.stopPropagation();
    }

    this.router.navigateByUrl(url);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event : any) {      
    this.checkWidth( Math.min(event.target.innerWidth, event.target.outerWidth) );
  }

  checkWidth(width: any){
    if (width < this.$l) {
      this.hideAt$l = true;
    } else {
      this.hideAt$l = false;
    }
  }

  switchLocale(locale: 'en' | 'fr') {
    this.activeLocale = locale;
    let baseUrl = window.location.origin;
    let currentRoute = this.router.url;
    window.location.href = `${baseUrl}/${this.activeLocale}${currentRoute}`;
  }

  parseInt(text: string) {
    return parseInt(text);
  }

  goToBranches(){    
    window.open('https://www.avenirenergy.ca/about-us-branches', "_blank");
  }
}
